const scrollContainers = document.querySelectorAll('.feedback-container, .ingredients-container');

scrollContainers.forEach((container) => {
  let isDown = false;
  let startX;
  let scrollLeft;

  container.addEventListener('mousedown', (e) => {
    isDown = true;
    container.classList.add('active'); // Apply grabbing cursor
    startX = e.pageX - container.offsetLeft;
    scrollLeft = container.scrollLeft;

    // Disable text selection while dragging
    container.style.userSelect = 'none';
  });

  container.addEventListener('mouseleave', () => {
    isDown = false;
    container.classList.remove('active');
    container.style.userSelect = ''; // Re-enable text selection
  });

  container.addEventListener('mouseup', () => {
    isDown = false;
    container.classList.remove('active');
    container.style.userSelect = ''; // Re-enable text selection
  });

  container.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - container.offsetLeft;
    const walk = (x - startX) * 2; // Adjust multiplier for scroll speed
    container.scrollLeft = scrollLeft - walk;
  });
});

const images = document.querySelectorAll(".scroll-container img");
images.forEach((img) => {
  img.setAttribute("draggable", "false");
});

container.addEventListener('mousedown', () => {
  container.style.userSelect = 'none'; // Disable text selection
});

container.addEventListener('mouseup', () => {
  container.style.userSelect = ''; // Re-enable text selection after drag
});